import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Accordion.css'; // Add your custom styles here
import { FaPlus } from 'react-icons/fa6';

const Accordion = ({ questions, className = "" }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // setActiveIndex(activeIndex === index ? null : index);
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div className=" accordion border-none">
            {questions.map((item, index) => (
                <div key={index} className="accordion-item mb-3">
                    <div
                        className={`accordion-question py-3 ${className} ${activeIndex == index ? "activeFaq text-white" : ""}`}
                        onClick={() => handleClick(index)}
                    >
                        {/* <h4 className='mb-0 d-flex'><span className='pe-3'>{item.id}.</span> {item.question}</h4> */}
                        <h4 className={`mb-0 d-flex pe-3`}><span className='pe-3'>{item.id}.</span> {item.question}</h4>
                        <div>
                            <i className={`${activeIndex === index ? 'rotate' : ''} fs-4`}><FaPlus /></i>
                        </div>
                    </div>

                    <CSSTransition
                        in={activeIndex === index}
                        timeout={300}
                        classNames="accordion-content"
                        // className="activeFaq"
                        unmountOnExit
                    >
                        <div className="accordion-answer">
                            <p>{item.answer}</p>
                        </div>
                    </CSSTransition>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
